module.exports = "<h3>Closing session...</h3>";


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/super_user/logout/logout.component.html
 ** module id = 275
 ** module chunks = 0
 **/